// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__spnwu","modalFooterButton":"ModalNotes_modalFooterButton__3o5xW"};